"use client";
import { j as ur } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as Te from "react";
import { useImperativeHandle as Ht, useEffect as G, createElement as cr, createContext as Wt, Children as ot, useRef as X, useState as Kt, useCallback as x, useMemo as Or, useLayoutEffect as qt, forwardRef as it, useContext as Xt } from "react";
import { g as Zt } from "./_commonjsHelpers-CXJ7dpIk.mjs";
import { u as Ve } from "./useEventCallback-CjuAhyNz.mjs";
import { F as kt } from "./FormContext-CYX6HnEQ.mjs";
import { u as Jt } from "./useRenderElement-B8V3_e8R.mjs";
const $r = {}, ut = /* @__PURE__ */ Te.forwardRef(function(r, t) {
  const {
    render: n,
    className: o,
    errors: i,
    onClearErrors: u,
    onSubmit: v,
    ...h
  } = r, d = Te.useRef({
    fields: /* @__PURE__ */ new Map()
  }), A = Te.useRef(!1), E = Ve(v), f = Ve(u), T = Ve((m) => {
    m.focus(), m.tagName === "INPUT" && m.select();
  });
  Te.useEffect(() => {
    if (!A.current)
      return;
    A.current = !1;
    const m = Array.from(d.current.fields.values()).filter((w) => w.validityData.state.valid === !1);
    m.length && T(m[0].controlRef.current);
  }, [i, T]);
  const S = Jt("form", r, {
    state: $r,
    ref: t,
    props: [{
      noValidate: !0,
      onSubmit(m) {
        let w = Array.from(d.current.fields.values());
        w.forEach((P) => {
          P.validate();
        }), w = Array.from(d.current.fields.values());
        const M = w.filter((P) => !P.validityData.state.valid);
        M.length ? (m.preventDefault(), T(M[0].controlRef.current)) : (A.current = !0, E(m));
      }
    }, h]
  }), F = Ve((m) => {
    if (m && i && $r.hasOwnProperty.call(i, m)) {
      const w = {
        ...i
      };
      delete w[m], f(w);
    }
  }), C = Te.useMemo(() => ({
    formRef: d,
    errors: i ?? {},
    clearErrors: F
  }), [d, i, F]);
  return /* @__PURE__ */ ur.jsx(kt.Provider, {
    value: C,
    children: S
  });
});
process.env.NODE_ENV !== "production" && (ut.displayName = "Form");
var Qt = function(r) {
  return en(r) && !rn(r);
};
function en(e) {
  return !!e && typeof e == "object";
}
function rn(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || an(e);
}
var tn = typeof Symbol == "function" && Symbol.for, nn = tn ? Symbol.for("react.element") : 60103;
function an(e) {
  return e.$$typeof === nn;
}
function on(e) {
  return Array.isArray(e) ? [] : {};
}
function Ye(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? Ae(on(e), e, r) : e;
}
function un(e, r, t) {
  return e.concat(r).map(function(n) {
    return Ye(n, t);
  });
}
function cn(e, r, t) {
  var n = {};
  return t.isMergeableObject(e) && Object.keys(e).forEach(function(o) {
    n[o] = Ye(e[o], t);
  }), Object.keys(r).forEach(function(o) {
    !t.isMergeableObject(r[o]) || !e[o] ? n[o] = Ye(r[o], t) : n[o] = Ae(e[o], r[o], t);
  }), n;
}
function Ae(e, r, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || un, t.isMergeableObject = t.isMergeableObject || Qt;
  var n = Array.isArray(r), o = Array.isArray(e), i = n === o;
  return i ? n ? t.arrayMerge(e, r, t) : cn(e, r, t) : Ye(r, t);
}
Ae.all = function(r, t) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(n, o) {
    return Ae(n, o, t);
  }, {});
};
var sr = Ae, ct = typeof global == "object" && global && global.Object === Object && global, sn = typeof self == "object" && self && self.Object === Object && self, Y = ct || sn || Function("return this")(), k = Y.Symbol, st = Object.prototype, fn = st.hasOwnProperty, ln = st.toString, Ee = k ? k.toStringTag : void 0;
function dn(e) {
  var r = fn.call(e, Ee), t = e[Ee];
  try {
    e[Ee] = void 0;
    var n = !0;
  } catch {
  }
  var o = ln.call(e);
  return n && (r ? e[Ee] = t : delete e[Ee]), o;
}
var pn = Object.prototype, vn = pn.toString;
function yn(e) {
  return vn.call(e);
}
var hn = "[object Null]", mn = "[object Undefined]", jr = k ? k.toStringTag : void 0;
function ae(e) {
  return e == null ? e === void 0 ? mn : hn : jr && jr in Object(e) ? dn(e) : yn(e);
}
function ft(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var yr = ft(Object.getPrototypeOf, Object);
function oe(e) {
  return e != null && typeof e == "object";
}
var gn = "[object Object]", bn = Function.prototype, Tn = Object.prototype, lt = bn.toString, En = Tn.hasOwnProperty, Sn = lt.call(Object);
function Cr(e) {
  if (!oe(e) || ae(e) != gn)
    return !1;
  var r = yr(e);
  if (r === null)
    return !0;
  var t = En.call(r, "constructor") && r.constructor;
  return typeof t == "function" && t instanceof t && lt.call(t) == Sn;
}
function _n() {
  this.__data__ = [], this.size = 0;
}
function dt(e, r) {
  return e === r || e !== e && r !== r;
}
function Ge(e, r) {
  for (var t = e.length; t--; )
    if (dt(e[t][0], r))
      return t;
  return -1;
}
var An = Array.prototype, On = An.splice;
function $n(e) {
  var r = this.__data__, t = Ge(r, e);
  if (t < 0)
    return !1;
  var n = r.length - 1;
  return t == n ? r.pop() : On.call(r, t, 1), --this.size, !0;
}
function jn(e) {
  var r = this.__data__, t = Ge(r, e);
  return t < 0 ? void 0 : r[t][1];
}
function Cn(e) {
  return Ge(this.__data__, e) > -1;
}
function Fn(e, r) {
  var t = this.__data__, n = Ge(t, e);
  return n < 0 ? (++this.size, t.push([e, r])) : t[n][1] = r, this;
}
function W(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
W.prototype.clear = _n;
W.prototype.delete = $n;
W.prototype.get = jn;
W.prototype.has = Cn;
W.prototype.set = Fn;
function wn() {
  this.__data__ = new W(), this.size = 0;
}
function Rn(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
function Pn(e) {
  return this.__data__.get(e);
}
function In(e) {
  return this.__data__.has(e);
}
function je(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var Mn = "[object AsyncFunction]", xn = "[object Function]", Nn = "[object GeneratorFunction]", Dn = "[object Proxy]";
function pt(e) {
  if (!je(e))
    return !1;
  var r = ae(e);
  return r == xn || r == Nn || r == Mn || r == Dn;
}
var rr = Y["__core-js_shared__"], Fr = function() {
  var e = /[^.]+$/.exec(rr && rr.keys && rr.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Ln(e) {
  return !!Fr && Fr in e;
}
var Vn = Function.prototype, Un = Vn.toString;
function ie(e) {
  if (e != null) {
    try {
      return Un.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Bn = /[\\^$.*+?()[\]{}|]/g, zn = /^\[object .+?Constructor\]$/, Yn = Function.prototype, Gn = Object.prototype, Hn = Yn.toString, Wn = Gn.hasOwnProperty, Kn = RegExp(
  "^" + Hn.call(Wn).replace(Bn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function qn(e) {
  if (!je(e) || Ln(e))
    return !1;
  var r = pt(e) ? Kn : zn;
  return r.test(ie(e));
}
function Xn(e, r) {
  return e == null ? void 0 : e[r];
}
function ue(e, r) {
  var t = Xn(e, r);
  return qn(t) ? t : void 0;
}
var Oe = ue(Y, "Map"), $e = ue(Object, "create");
function Zn() {
  this.__data__ = $e ? $e(null) : {}, this.size = 0;
}
function kn(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var Jn = "__lodash_hash_undefined__", Qn = Object.prototype, ea = Qn.hasOwnProperty;
function ra(e) {
  var r = this.__data__;
  if ($e) {
    var t = r[e];
    return t === Jn ? void 0 : t;
  }
  return ea.call(r, e) ? r[e] : void 0;
}
var ta = Object.prototype, na = ta.hasOwnProperty;
function aa(e) {
  var r = this.__data__;
  return $e ? r[e] !== void 0 : na.call(r, e);
}
var oa = "__lodash_hash_undefined__";
function ia(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = $e && r === void 0 ? oa : r, this;
}
function ne(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
ne.prototype.clear = Zn;
ne.prototype.delete = kn;
ne.prototype.get = ra;
ne.prototype.has = aa;
ne.prototype.set = ia;
function ua() {
  this.size = 0, this.__data__ = {
    hash: new ne(),
    map: new (Oe || W)(),
    string: new ne()
  };
}
function ca(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
function He(e, r) {
  var t = e.__data__;
  return ca(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
function sa(e) {
  var r = He(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
function fa(e) {
  return He(this, e).get(e);
}
function la(e) {
  return He(this, e).has(e);
}
function da(e, r) {
  var t = He(this, e), n = t.size;
  return t.set(e, r), this.size += t.size == n ? 0 : 1, this;
}
function J(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
J.prototype.clear = ua;
J.prototype.delete = sa;
J.prototype.get = fa;
J.prototype.has = la;
J.prototype.set = da;
var pa = 200;
function va(e, r) {
  var t = this.__data__;
  if (t instanceof W) {
    var n = t.__data__;
    if (!Oe || n.length < pa - 1)
      return n.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new J(n);
  }
  return t.set(e, r), this.size = t.size, this;
}
function de(e) {
  var r = this.__data__ = new W(e);
  this.size = r.size;
}
de.prototype.clear = wn;
de.prototype.delete = Rn;
de.prototype.get = Pn;
de.prototype.has = In;
de.prototype.set = va;
function ya(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n && r(e[t], t, e) !== !1; )
    ;
  return e;
}
var wr = function() {
  try {
    var e = ue(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
function vt(e, r, t) {
  r == "__proto__" && wr ? wr(e, r, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[r] = t;
}
var ha = Object.prototype, ma = ha.hasOwnProperty;
function yt(e, r, t) {
  var n = e[r];
  (!(ma.call(e, r) && dt(n, t)) || t === void 0 && !(r in e)) && vt(e, r, t);
}
function We(e, r, t, n) {
  var o = !t;
  t || (t = {});
  for (var i = -1, u = r.length; ++i < u; ) {
    var v = r[i], h = void 0;
    h === void 0 && (h = e[v]), o ? vt(t, v, h) : yt(t, v, h);
  }
  return t;
}
function ga(e, r) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = r(t);
  return n;
}
var ba = "[object Arguments]";
function Rr(e) {
  return oe(e) && ae(e) == ba;
}
var ht = Object.prototype, Ta = ht.hasOwnProperty, Ea = ht.propertyIsEnumerable, Sa = Rr(/* @__PURE__ */ function() {
  return arguments;
}()) ? Rr : function(e) {
  return oe(e) && Ta.call(e, "callee") && !Ea.call(e, "callee");
}, Ce = Array.isArray;
function _a() {
  return !1;
}
var mt = typeof exports == "object" && exports && !exports.nodeType && exports, Pr = mt && typeof module == "object" && module && !module.nodeType && module, Aa = Pr && Pr.exports === mt, Ir = Aa ? Y.Buffer : void 0, Oa = Ir ? Ir.isBuffer : void 0, gt = Oa || _a, $a = 9007199254740991, ja = /^(?:0|[1-9]\d*)$/;
function Ca(e, r) {
  var t = typeof e;
  return r = r ?? $a, !!r && (t == "number" || t != "symbol" && ja.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var Fa = 9007199254740991;
function bt(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Fa;
}
var wa = "[object Arguments]", Ra = "[object Array]", Pa = "[object Boolean]", Ia = "[object Date]", Ma = "[object Error]", xa = "[object Function]", Na = "[object Map]", Da = "[object Number]", La = "[object Object]", Va = "[object RegExp]", Ua = "[object Set]", Ba = "[object String]", za = "[object WeakMap]", Ya = "[object ArrayBuffer]", Ga = "[object DataView]", Ha = "[object Float32Array]", Wa = "[object Float64Array]", Ka = "[object Int8Array]", qa = "[object Int16Array]", Xa = "[object Int32Array]", Za = "[object Uint8Array]", ka = "[object Uint8ClampedArray]", Ja = "[object Uint16Array]", Qa = "[object Uint32Array]", I = {};
I[Ha] = I[Wa] = I[Ka] = I[qa] = I[Xa] = I[Za] = I[ka] = I[Ja] = I[Qa] = !0;
I[wa] = I[Ra] = I[Ya] = I[Pa] = I[Ga] = I[Ia] = I[Ma] = I[xa] = I[Na] = I[Da] = I[La] = I[Va] = I[Ua] = I[Ba] = I[za] = !1;
function eo(e) {
  return oe(e) && bt(e.length) && !!I[ae(e)];
}
function hr(e) {
  return function(r) {
    return e(r);
  };
}
var Tt = typeof exports == "object" && exports && !exports.nodeType && exports, Se = Tt && typeof module == "object" && module && !module.nodeType && module, ro = Se && Se.exports === Tt, tr = ro && ct.process, le = function() {
  try {
    var e = Se && Se.require && Se.require("util").types;
    return e || tr && tr.binding && tr.binding("util");
  } catch {
  }
}(), Mr = le && le.isTypedArray, to = Mr ? hr(Mr) : eo, no = Object.prototype, ao = no.hasOwnProperty;
function Et(e, r) {
  var t = Ce(e), n = !t && Sa(e), o = !t && !n && gt(e), i = !t && !n && !o && to(e), u = t || n || o || i, v = u ? ga(e.length, String) : [], h = v.length;
  for (var d in e)
    (r || ao.call(e, d)) && !(u && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    Ca(d, h))) && v.push(d);
  return v;
}
var oo = Object.prototype;
function mr(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || oo;
  return e === t;
}
var io = ft(Object.keys, Object), uo = Object.prototype, co = uo.hasOwnProperty;
function so(e) {
  if (!mr(e))
    return io(e);
  var r = [];
  for (var t in Object(e))
    co.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
function St(e) {
  return e != null && bt(e.length) && !pt(e);
}
function gr(e) {
  return St(e) ? Et(e) : so(e);
}
function fo(e, r) {
  return e && We(r, gr(r), e);
}
function lo(e) {
  var r = [];
  if (e != null)
    for (var t in Object(e))
      r.push(t);
  return r;
}
var po = Object.prototype, vo = po.hasOwnProperty;
function yo(e) {
  if (!je(e))
    return lo(e);
  var r = mr(e), t = [];
  for (var n in e)
    n == "constructor" && (r || !vo.call(e, n)) || t.push(n);
  return t;
}
function br(e) {
  return St(e) ? Et(e, !0) : yo(e);
}
function ho(e, r) {
  return e && We(r, br(r), e);
}
var _t = typeof exports == "object" && exports && !exports.nodeType && exports, xr = _t && typeof module == "object" && module && !module.nodeType && module, mo = xr && xr.exports === _t, Nr = mo ? Y.Buffer : void 0, Dr = Nr ? Nr.allocUnsafe : void 0;
function go(e, r) {
  if (r)
    return e.slice();
  var t = e.length, n = Dr ? Dr(t) : new e.constructor(t);
  return e.copy(n), n;
}
function At(e, r) {
  var t = -1, n = e.length;
  for (r || (r = Array(n)); ++t < n; )
    r[t] = e[t];
  return r;
}
function bo(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, o = 0, i = []; ++t < n; ) {
    var u = e[t];
    r(u, t, e) && (i[o++] = u);
  }
  return i;
}
function Ot() {
  return [];
}
var To = Object.prototype, Eo = To.propertyIsEnumerable, Lr = Object.getOwnPropertySymbols, Tr = Lr ? function(e) {
  return e == null ? [] : (e = Object(e), bo(Lr(e), function(r) {
    return Eo.call(e, r);
  }));
} : Ot;
function So(e, r) {
  return We(e, Tr(e), r);
}
function $t(e, r) {
  for (var t = -1, n = r.length, o = e.length; ++t < n; )
    e[o + t] = r[t];
  return e;
}
var _o = Object.getOwnPropertySymbols, jt = _o ? function(e) {
  for (var r = []; e; )
    $t(r, Tr(e)), e = yr(e);
  return r;
} : Ot;
function Ao(e, r) {
  return We(e, jt(e), r);
}
function Ct(e, r, t) {
  var n = r(e);
  return Ce(e) ? n : $t(n, t(e));
}
function Oo(e) {
  return Ct(e, gr, Tr);
}
function $o(e) {
  return Ct(e, br, jt);
}
var fr = ue(Y, "DataView"), lr = ue(Y, "Promise"), dr = ue(Y, "Set"), pr = ue(Y, "WeakMap"), Vr = "[object Map]", jo = "[object Object]", Ur = "[object Promise]", Br = "[object Set]", zr = "[object WeakMap]", Yr = "[object DataView]", Co = ie(fr), Fo = ie(Oe), wo = ie(lr), Ro = ie(dr), Po = ie(pr), H = ae;
(fr && H(new fr(new ArrayBuffer(1))) != Yr || Oe && H(new Oe()) != Vr || lr && H(lr.resolve()) != Ur || dr && H(new dr()) != Br || pr && H(new pr()) != zr) && (H = function(e) {
  var r = ae(e), t = r == jo ? e.constructor : void 0, n = t ? ie(t) : "";
  if (n)
    switch (n) {
      case Co:
        return Yr;
      case Fo:
        return Vr;
      case wo:
        return Ur;
      case Ro:
        return Br;
      case Po:
        return zr;
    }
  return r;
});
var Io = Object.prototype, Mo = Io.hasOwnProperty;
function xo(e) {
  var r = e.length, t = new e.constructor(r);
  return r && typeof e[0] == "string" && Mo.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var Gr = Y.Uint8Array;
function Er(e) {
  var r = new e.constructor(e.byteLength);
  return new Gr(r).set(new Gr(e)), r;
}
function No(e, r) {
  var t = r ? Er(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var Do = /\w*$/;
function Lo(e) {
  var r = new e.constructor(e.source, Do.exec(e));
  return r.lastIndex = e.lastIndex, r;
}
var Hr = k ? k.prototype : void 0, Wr = Hr ? Hr.valueOf : void 0;
function Vo(e) {
  return Wr ? Object(Wr.call(e)) : {};
}
function Uo(e, r) {
  var t = r ? Er(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var Bo = "[object Boolean]", zo = "[object Date]", Yo = "[object Map]", Go = "[object Number]", Ho = "[object RegExp]", Wo = "[object Set]", Ko = "[object String]", qo = "[object Symbol]", Xo = "[object ArrayBuffer]", Zo = "[object DataView]", ko = "[object Float32Array]", Jo = "[object Float64Array]", Qo = "[object Int8Array]", ei = "[object Int16Array]", ri = "[object Int32Array]", ti = "[object Uint8Array]", ni = "[object Uint8ClampedArray]", ai = "[object Uint16Array]", oi = "[object Uint32Array]";
function ii(e, r, t) {
  var n = e.constructor;
  switch (r) {
    case Xo:
      return Er(e);
    case Bo:
    case zo:
      return new n(+e);
    case Zo:
      return No(e, t);
    case ko:
    case Jo:
    case Qo:
    case ei:
    case ri:
    case ti:
    case ni:
    case ai:
    case oi:
      return Uo(e, t);
    case Yo:
      return new n();
    case Go:
    case Ko:
      return new n(e);
    case Ho:
      return Lo(e);
    case Wo:
      return new n();
    case qo:
      return Vo(e);
  }
}
var Kr = Object.create, ui = /* @__PURE__ */ function() {
  function e() {
  }
  return function(r) {
    if (!je(r))
      return {};
    if (Kr)
      return Kr(r);
    e.prototype = r;
    var t = new e();
    return e.prototype = void 0, t;
  };
}();
function ci(e) {
  return typeof e.constructor == "function" && !mr(e) ? ui(yr(e)) : {};
}
var si = "[object Map]";
function fi(e) {
  return oe(e) && H(e) == si;
}
var qr = le && le.isMap, li = qr ? hr(qr) : fi, di = "[object Set]";
function pi(e) {
  return oe(e) && H(e) == di;
}
var Xr = le && le.isSet, vi = Xr ? hr(Xr) : pi, yi = 1, hi = 2, mi = 4, Ft = "[object Arguments]", gi = "[object Array]", bi = "[object Boolean]", Ti = "[object Date]", Ei = "[object Error]", wt = "[object Function]", Si = "[object GeneratorFunction]", _i = "[object Map]", Ai = "[object Number]", Rt = "[object Object]", Oi = "[object RegExp]", $i = "[object Set]", ji = "[object String]", Ci = "[object Symbol]", Fi = "[object WeakMap]", wi = "[object ArrayBuffer]", Ri = "[object DataView]", Pi = "[object Float32Array]", Ii = "[object Float64Array]", Mi = "[object Int8Array]", xi = "[object Int16Array]", Ni = "[object Int32Array]", Di = "[object Uint8Array]", Li = "[object Uint8ClampedArray]", Vi = "[object Uint16Array]", Ui = "[object Uint32Array]", R = {};
R[Ft] = R[gi] = R[wi] = R[Ri] = R[bi] = R[Ti] = R[Pi] = R[Ii] = R[Mi] = R[xi] = R[Ni] = R[_i] = R[Ai] = R[Rt] = R[Oi] = R[$i] = R[ji] = R[Ci] = R[Di] = R[Li] = R[Vi] = R[Ui] = !0;
R[Ei] = R[wt] = R[Fi] = !1;
function _e(e, r, t, n, o, i) {
  var u, v = r & yi, h = r & hi, d = r & mi;
  if (u !== void 0)
    return u;
  if (!je(e))
    return e;
  var A = Ce(e);
  if (A) {
    if (u = xo(e), !v)
      return At(e, u);
  } else {
    var E = H(e), f = E == wt || E == Si;
    if (gt(e))
      return go(e, v);
    if (E == Rt || E == Ft || f && !o) {
      if (u = h || f ? {} : ci(e), !v)
        return h ? Ao(e, ho(u, e)) : So(e, fo(u, e));
    } else {
      if (!R[E])
        return o ? e : {};
      u = ii(e, E, v);
    }
  }
  i || (i = new de());
  var T = i.get(e);
  if (T)
    return T;
  i.set(e, u), vi(e) ? e.forEach(function(C) {
    u.add(_e(C, r, t, C, e, i));
  }) : li(e) && e.forEach(function(C, m) {
    u.set(m, _e(C, r, t, m, e, i));
  });
  var S = d ? h ? $o : Oo : h ? br : gr, F = A ? void 0 : S(e);
  return ya(F || e, function(C, m) {
    F && (m = C, C = e[m]), yt(u, m, _e(C, r, t, m, e, i));
  }), u;
}
var Bi = 1, zi = 4;
function Ue(e) {
  return _e(e, Bi | zi);
}
var nr, Zr;
function Yi() {
  if (Zr) return nr;
  Zr = 1;
  var e = Array.isArray, r = Object.keys, t = Object.prototype.hasOwnProperty, n = typeof Element < "u";
  function o(i, u) {
    if (i === u) return !0;
    if (i && u && typeof i == "object" && typeof u == "object") {
      var v = e(i), h = e(u), d, A, E;
      if (v && h) {
        if (A = i.length, A != u.length) return !1;
        for (d = A; d-- !== 0; )
          if (!o(i[d], u[d])) return !1;
        return !0;
      }
      if (v != h) return !1;
      var f = i instanceof Date, T = u instanceof Date;
      if (f != T) return !1;
      if (f && T) return i.getTime() == u.getTime();
      var S = i instanceof RegExp, F = u instanceof RegExp;
      if (S != F) return !1;
      if (S && F) return i.toString() == u.toString();
      var C = r(i);
      if (A = C.length, A !== r(u).length)
        return !1;
      for (d = A; d-- !== 0; )
        if (!t.call(u, C[d])) return !1;
      if (n && i instanceof Element && u instanceof Element)
        return i === u;
      for (d = A; d-- !== 0; )
        if (E = C[d], !(E === "_owner" && i.$$typeof) && !o(i[E], u[E]))
          return !1;
      return !0;
    }
    return i !== i && u !== u;
  }
  return nr = function(u, v) {
    try {
      return o(u, v);
    } catch (h) {
      if (h.message && h.message.match(/stack|recursion/i) || h.number === -2146828260)
        return console.warn("Warning: react-fast-compare does not handle circular references.", h.name, h.message), !1;
      throw h;
    }
  }, nr;
}
var Gi = Yi();
const re = /* @__PURE__ */ Zt(Gi);
var Hi = process.env.NODE_ENV === "production";
function Z(e, r) {
  if (!Hi) {
    var t = "Warning: " + r;
    typeof console < "u" && console.warn(t);
    try {
      throw Error(t);
    } catch {
    }
  }
}
var Wi = 4;
function kr(e) {
  return _e(e, Wi);
}
function Pt(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, o = Array(n); ++t < n; )
    o[t] = r(e[t], t, e);
  return o;
}
var Ki = "[object Symbol]";
function Sr(e) {
  return typeof e == "symbol" || oe(e) && ae(e) == Ki;
}
var qi = "Expected a function";
function _r(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(qi);
  var t = function() {
    var n = arguments, o = r ? r.apply(this, n) : n[0], i = t.cache;
    if (i.has(o))
      return i.get(o);
    var u = e.apply(this, n);
    return t.cache = i.set(o, u) || i, u;
  };
  return t.cache = new (_r.Cache || J)(), t;
}
_r.Cache = J;
var Xi = 500;
function Zi(e) {
  var r = _r(e, function(n) {
    return t.size === Xi && t.clear(), n;
  }), t = r.cache;
  return r;
}
var ki = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ji = /\\(\\)?/g, Qi = Zi(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(ki, function(t, n, o, i) {
    r.push(o ? i.replace(Ji, "$1") : n || t);
  }), r;
});
function eu(e) {
  if (typeof e == "string" || Sr(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -1 / 0 ? "-0" : r;
}
var Jr = k ? k.prototype : void 0, Qr = Jr ? Jr.toString : void 0;
function It(e) {
  if (typeof e == "string")
    return e;
  if (Ce(e))
    return Pt(e, It) + "";
  if (Sr(e))
    return Qr ? Qr.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -1 / 0 ? "-0" : r;
}
function ru(e) {
  return e == null ? "" : It(e);
}
function Mt(e) {
  return Ce(e) ? Pt(e, eu) : Sr(e) ? [e] : At(Qi(ru(e)));
}
var Be = { exports: {} }, $ = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var et;
function tu() {
  if (et) return $;
  et = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, v = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, A = e ? Symbol.for("react.forward_ref") : 60112, E = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, F = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function M(c) {
    if (typeof c == "object" && c !== null) {
      var g = c.$$typeof;
      switch (g) {
        case r:
          switch (c = c.type, c) {
            case h:
            case d:
            case n:
            case i:
            case o:
            case E:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case v:
                case A:
                case S:
                case T:
                case u:
                  return c;
                default:
                  return g;
              }
          }
        case t:
          return g;
      }
    }
  }
  function P(c) {
    return M(c) === d;
  }
  return $.AsyncMode = h, $.ConcurrentMode = d, $.ContextConsumer = v, $.ContextProvider = u, $.Element = r, $.ForwardRef = A, $.Fragment = n, $.Lazy = S, $.Memo = T, $.Portal = t, $.Profiler = i, $.StrictMode = o, $.Suspense = E, $.isAsyncMode = function(c) {
    return P(c) || M(c) === h;
  }, $.isConcurrentMode = P, $.isContextConsumer = function(c) {
    return M(c) === v;
  }, $.isContextProvider = function(c) {
    return M(c) === u;
  }, $.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, $.isForwardRef = function(c) {
    return M(c) === A;
  }, $.isFragment = function(c) {
    return M(c) === n;
  }, $.isLazy = function(c) {
    return M(c) === S;
  }, $.isMemo = function(c) {
    return M(c) === T;
  }, $.isPortal = function(c) {
    return M(c) === t;
  }, $.isProfiler = function(c) {
    return M(c) === i;
  }, $.isStrictMode = function(c) {
    return M(c) === o;
  }, $.isSuspense = function(c) {
    return M(c) === E;
  }, $.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === n || c === d || c === i || c === o || c === E || c === f || typeof c == "object" && c !== null && (c.$$typeof === S || c.$$typeof === T || c.$$typeof === u || c.$$typeof === v || c.$$typeof === A || c.$$typeof === C || c.$$typeof === m || c.$$typeof === w || c.$$typeof === F);
  }, $.typeOf = M, $;
}
var j = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rt;
function nu() {
  return rt || (rt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, v = e ? Symbol.for("react.context") : 60110, h = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, A = e ? Symbol.for("react.forward_ref") : 60112, E = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, F = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function M(p) {
      return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      p === n || p === d || p === i || p === o || p === E || p === f || typeof p == "object" && p !== null && (p.$$typeof === S || p.$$typeof === T || p.$$typeof === u || p.$$typeof === v || p.$$typeof === A || p.$$typeof === C || p.$$typeof === m || p.$$typeof === w || p.$$typeof === F);
    }
    function P(p) {
      if (typeof p == "object" && p !== null) {
        var se = p.$$typeof;
        switch (se) {
          case r:
            var fe = p.type;
            switch (fe) {
              case h:
              case d:
              case n:
              case i:
              case o:
              case E:
                return fe;
              default:
                var Le = fe && fe.$$typeof;
                switch (Le) {
                  case v:
                  case A:
                  case S:
                  case T:
                  case u:
                    return Le;
                  default:
                    return se;
                }
            }
          case t:
            return se;
        }
      }
    }
    var c = h, g = d, _ = v, pe = u, ve = r, Fe = A, we = n, Xe = S, L = T, Q = t, Re = i, Ze = o, ke = E, ye = !1;
    function Pe(p) {
      return ye || (ye = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), he(p) || P(p) === h;
    }
    function he(p) {
      return P(p) === d;
    }
    function ce(p) {
      return P(p) === v;
    }
    function K(p) {
      return P(p) === u;
    }
    function Ie(p) {
      return typeof p == "object" && p !== null && p.$$typeof === r;
    }
    function me(p) {
      return P(p) === A;
    }
    function q(p) {
      return P(p) === n;
    }
    function Me(p) {
      return P(p) === S;
    }
    function ge(p) {
      return P(p) === T;
    }
    function xe(p) {
      return P(p) === t;
    }
    function Ne(p) {
      return P(p) === i;
    }
    function De(p) {
      return P(p) === o;
    }
    function be(p) {
      return P(p) === E;
    }
    j.AsyncMode = c, j.ConcurrentMode = g, j.ContextConsumer = _, j.ContextProvider = pe, j.Element = ve, j.ForwardRef = Fe, j.Fragment = we, j.Lazy = Xe, j.Memo = L, j.Portal = Q, j.Profiler = Re, j.StrictMode = Ze, j.Suspense = ke, j.isAsyncMode = Pe, j.isConcurrentMode = he, j.isContextConsumer = ce, j.isContextProvider = K, j.isElement = Ie, j.isForwardRef = me, j.isFragment = q, j.isLazy = Me, j.isMemo = ge, j.isPortal = xe, j.isProfiler = Ne, j.isStrictMode = De, j.isSuspense = be, j.isValidElementType = M, j.typeOf = P;
  }()), j;
}
var tt;
function au() {
  return tt || (tt = 1, process.env.NODE_ENV === "production" ? Be.exports = tu() : Be.exports = nu()), Be.exports;
}
var ar, nt;
function ou() {
  if (nt) return ar;
  nt = 1;
  var e = au(), r = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, t = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, n = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = n, i[e.Memo] = o;
  function u(S) {
    return e.isMemo(S) ? o : i[S.$$typeof] || r;
  }
  var v = Object.defineProperty, h = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, A = Object.getOwnPropertyDescriptor, E = Object.getPrototypeOf, f = Object.prototype;
  function T(S, F, C) {
    if (typeof F != "string") {
      if (f) {
        var m = E(F);
        m && m !== f && T(S, m, C);
      }
      var w = h(F);
      d && (w = w.concat(d(F)));
      for (var M = u(S), P = u(F), c = 0; c < w.length; ++c) {
        var g = w[c];
        if (!t[g] && !(C && C[g]) && !(P && P[g]) && !(M && M[g])) {
          var _ = A(F, g);
          try {
            v(S, g, _);
          } catch {
          }
        }
      }
    }
    return S;
  }
  return ar = T, ar;
}
ou();
function D() {
  return D = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, D.apply(this, arguments);
}
function xt(e, r) {
  if (e == null) return {};
  var t = {}, n = Object.keys(e), o, i;
  for (i = 0; i < n.length; i++)
    o = n[i], !(r.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
var Ke = /* @__PURE__ */ Wt(void 0);
Ke.displayName = "FormikContext";
var iu = Ke.Provider;
Ke.Consumer;
function uu() {
  var e = Xt(Ke);
  return e || (process.env.NODE_ENV !== "production" ? Z(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : Z()), e;
}
var B = function(r) {
  return typeof r == "function";
}, qe = function(r) {
  return r !== null && typeof r == "object";
}, cu = function(r) {
  return String(Math.floor(Number(r))) === r;
}, or = function(r) {
  return Object.prototype.toString.call(r) === "[object String]";
}, su = function(r) {
  return ot.count(r) === 0;
}, ir = function(r) {
  return qe(r) && B(r.then);
};
function fu(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function V(e, r, t, n) {
  n === void 0 && (n = 0);
  for (var o = Mt(r); e && n < o.length; )
    e = e[o[n++]];
  return n !== o.length && !e || e === void 0 ? t : e;
}
function te(e, r, t) {
  for (var n = kr(e), o = n, i = 0, u = Mt(r); i < u.length - 1; i++) {
    var v = u[i], h = V(e, u.slice(0, i + 1));
    if (h && (qe(h) || Array.isArray(h)))
      o = o[v] = kr(h);
    else {
      var d = u[i + 1];
      o = o[v] = cu(d) && Number(d) >= 0 ? [] : {};
    }
  }
  return (i === 0 ? e : o)[u[i]] === t ? e : (t === void 0 ? delete o[u[i]] : o[u[i]] = t, i === 0 && t === void 0 && delete n[u[i]], n);
}
function Nt(e, r, t, n) {
  t === void 0 && (t = /* @__PURE__ */ new WeakMap()), n === void 0 && (n = {});
  for (var o = 0, i = Object.keys(e); o < i.length; o++) {
    var u = i[o], v = e[u];
    qe(v) ? t.get(v) || (t.set(v, !0), n[u] = Array.isArray(v) ? [] : {}, Nt(v, r, t, n[u])) : n[u] = r;
  }
  return n;
}
function lu(e, r) {
  switch (r.type) {
    case "SET_VALUES":
      return D({}, e, {
        values: r.payload
      });
    case "SET_TOUCHED":
      return D({}, e, {
        touched: r.payload
      });
    case "SET_ERRORS":
      return re(e.errors, r.payload) ? e : D({}, e, {
        errors: r.payload
      });
    case "SET_STATUS":
      return D({}, e, {
        status: r.payload
      });
    case "SET_ISSUBMITTING":
      return D({}, e, {
        isSubmitting: r.payload
      });
    case "SET_ISVALIDATING":
      return D({}, e, {
        isValidating: r.payload
      });
    case "SET_FIELD_VALUE":
      return D({}, e, {
        values: te(e.values, r.payload.field, r.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return D({}, e, {
        touched: te(e.touched, r.payload.field, r.payload.value)
      });
    case "SET_FIELD_ERROR":
      return D({}, e, {
        errors: te(e.errors, r.payload.field, r.payload.value)
      });
    case "RESET_FORM":
      return D({}, e, r.payload);
    case "SET_FORMIK_STATE":
      return r.payload(e);
    case "SUBMIT_ATTEMPT":
      return D({}, e, {
        touched: Nt(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return D({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return D({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var ee = {}, ze = {};
function du(e) {
  var r = e.validateOnChange, t = r === void 0 ? !0 : r, n = e.validateOnBlur, o = n === void 0 ? !0 : n, i = e.validateOnMount, u = i === void 0 ? !1 : i, v = e.isInitialValid, h = e.enableReinitialize, d = h === void 0 ? !1 : h, A = e.onSubmit, E = xt(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), f = D({
    validateOnChange: t,
    validateOnBlur: o,
    validateOnMount: u,
    onSubmit: A
  }, E), T = X(f.initialValues), S = X(f.initialErrors || ee), F = X(f.initialTouched || ze), C = X(f.initialStatus), m = X(!1), w = X({});
  process.env.NODE_ENV !== "production" && G(function() {
    typeof v > "u" || (process.env.NODE_ENV !== "production" ? Z(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : Z());
  }, []), G(function() {
    return m.current = !0, function() {
      m.current = !1;
    };
  }, []);
  var M = Kt(0), P = M[1], c = X({
    values: Ue(f.initialValues),
    errors: Ue(f.initialErrors) || ee,
    touched: Ue(f.initialTouched) || ze,
    status: Ue(f.initialStatus),
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), g = c.current, _ = x(function(a) {
    var s = c.current;
    c.current = lu(s, a), s !== c.current && P(function(l) {
      return l + 1;
    });
  }, []), pe = x(function(a, s) {
    return new Promise(function(l, y) {
      var b = f.validate(a, s);
      b == null ? l(ee) : ir(b) ? b.then(function(O) {
        l(O || ee);
      }, function(O) {
        process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", O), y(O);
      }) : l(b);
    });
  }, [f.validate]), ve = x(function(a, s) {
    var l = f.validationSchema, y = B(l) ? l(s) : l, b = s && y.validateAt ? y.validateAt(s, a) : yu(a, y);
    return new Promise(function(O, N) {
      b.then(function() {
        O(ee);
      }, function(z) {
        z.name === "ValidationError" ? O(vu(z)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", z), N(z));
      });
    });
  }, [f.validationSchema]), Fe = x(function(a, s) {
    return new Promise(function(l) {
      return l(w.current[a].validate(s));
    });
  }, []), we = x(function(a) {
    var s = Object.keys(w.current).filter(function(y) {
      return B(w.current[y].validate);
    }), l = s.length > 0 ? s.map(function(y) {
      return Fe(y, V(a, y));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(l).then(function(y) {
      return y.reduce(function(b, O, N) {
        return O === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || O && (b = te(b, s[N], O)), b;
      }, {});
    });
  }, [Fe]), Xe = x(function(a) {
    return Promise.all([we(a), f.validationSchema ? ve(a) : {}, f.validate ? pe(a) : {}]).then(function(s) {
      var l = s[0], y = s[1], b = s[2], O = sr.all([l, y, b], {
        arrayMerge: hu
      });
      return O;
    });
  }, [f.validate, f.validationSchema, we, pe, ve]), L = U(function(a) {
    return a === void 0 && (a = g.values), _({
      type: "SET_ISVALIDATING",
      payload: !0
    }), Xe(a).then(function(s) {
      return m.current && (_({
        type: "SET_ISVALIDATING",
        payload: !1
      }), _({
        type: "SET_ERRORS",
        payload: s
      })), s;
    });
  });
  G(function() {
    u && m.current === !0 && re(T.current, f.initialValues) && L(T.current);
  }, [u, L]);
  var Q = x(function(a) {
    var s = a && a.values ? a.values : T.current, l = a && a.errors ? a.errors : S.current ? S.current : f.initialErrors || {}, y = a && a.touched ? a.touched : F.current ? F.current : f.initialTouched || {}, b = a && a.status ? a.status : C.current ? C.current : f.initialStatus;
    T.current = s, S.current = l, F.current = y, C.current = b;
    var O = function() {
      _({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!a && !!a.isSubmitting,
          errors: l,
          touched: y,
          status: b,
          values: s,
          isValidating: !!a && !!a.isValidating,
          submitCount: a && a.submitCount && typeof a.submitCount == "number" ? a.submitCount : 0
        }
      });
    };
    if (f.onReset) {
      var N = f.onReset(g.values, se);
      ir(N) ? N.then(O) : O();
    } else
      O();
  }, [f.initialErrors, f.initialStatus, f.initialTouched, f.onReset]);
  G(function() {
    m.current === !0 && !re(T.current, f.initialValues) && d && (T.current = f.initialValues, Q(), u && L(T.current));
  }, [d, f.initialValues, Q, u, L]), G(function() {
    d && m.current === !0 && !re(S.current, f.initialErrors) && (S.current = f.initialErrors || ee, _({
      type: "SET_ERRORS",
      payload: f.initialErrors || ee
    }));
  }, [d, f.initialErrors]), G(function() {
    d && m.current === !0 && !re(F.current, f.initialTouched) && (F.current = f.initialTouched || ze, _({
      type: "SET_TOUCHED",
      payload: f.initialTouched || ze
    }));
  }, [d, f.initialTouched]), G(function() {
    d && m.current === !0 && !re(C.current, f.initialStatus) && (C.current = f.initialStatus, _({
      type: "SET_STATUS",
      payload: f.initialStatus
    }));
  }, [d, f.initialStatus, f.initialTouched]);
  var Re = U(function(a) {
    if (w.current[a] && B(w.current[a].validate)) {
      var s = V(g.values, a), l = w.current[a].validate(s);
      return ir(l) ? (_({
        type: "SET_ISVALIDATING",
        payload: !0
      }), l.then(function(y) {
        return y;
      }).then(function(y) {
        _({
          type: "SET_FIELD_ERROR",
          payload: {
            field: a,
            value: y
          }
        }), _({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (_({
        type: "SET_FIELD_ERROR",
        payload: {
          field: a,
          value: l
        }
      }), Promise.resolve(l));
    } else if (f.validationSchema)
      return _({
        type: "SET_ISVALIDATING",
        payload: !0
      }), ve(g.values, a).then(function(y) {
        return y;
      }).then(function(y) {
        _({
          type: "SET_FIELD_ERROR",
          payload: {
            field: a,
            value: V(y, a)
          }
        }), _({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), Ze = x(function(a, s) {
    var l = s.validate;
    w.current[a] = {
      validate: l
    };
  }, []), ke = x(function(a) {
    delete w.current[a];
  }, []), ye = U(function(a, s) {
    _({
      type: "SET_TOUCHED",
      payload: a
    });
    var l = s === void 0 ? o : s;
    return l ? L(g.values) : Promise.resolve();
  }), Pe = x(function(a) {
    _({
      type: "SET_ERRORS",
      payload: a
    });
  }, []), he = U(function(a, s) {
    var l = B(a) ? a(g.values) : a;
    _({
      type: "SET_VALUES",
      payload: l
    });
    var y = s === void 0 ? t : s;
    return y ? L(l) : Promise.resolve();
  }), ce = x(function(a, s) {
    _({
      type: "SET_FIELD_ERROR",
      payload: {
        field: a,
        value: s
      }
    });
  }, []), K = U(function(a, s, l) {
    _({
      type: "SET_FIELD_VALUE",
      payload: {
        field: a,
        value: s
      }
    });
    var y = l === void 0 ? t : l;
    return y ? L(te(g.values, a, s)) : Promise.resolve();
  }), Ie = x(function(a, s) {
    var l = s, y = a, b;
    if (!or(a)) {
      a.persist && a.persist();
      var O = a.target ? a.target : a.currentTarget, N = O.type, z = O.name, Qe = O.id, er = O.value, zt = O.checked, Yt = O.outerHTML, Ar = O.options, Gt = O.multiple;
      l = s || z || Qe, !l && process.env.NODE_ENV !== "production" && at({
        htmlContent: Yt,
        documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
        handlerName: "handleChange"
      }), y = /number|range/.test(N) ? (b = parseFloat(er), isNaN(b) ? "" : b) : /checkbox/.test(N) ? gu(V(g.values, l), zt, er) : Ar && Gt ? mu(Ar) : er;
    }
    l && K(l, y);
  }, [K, g.values]), me = U(function(a) {
    if (or(a))
      return function(s) {
        return Ie(s, a);
      };
    Ie(a);
  }), q = U(function(a, s, l) {
    s === void 0 && (s = !0), _({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: a,
        value: s
      }
    });
    var y = l === void 0 ? o : l;
    return y ? L(g.values) : Promise.resolve();
  }), Me = x(function(a, s) {
    a.persist && a.persist();
    var l = a.target, y = l.name, b = l.id, O = l.outerHTML, N = s || y || b;
    !N && process.env.NODE_ENV !== "production" && at({
      htmlContent: O,
      documentationAnchorLink: "handleblur-e-any--void",
      handlerName: "handleBlur"
    }), q(N, !0);
  }, [q]), ge = U(function(a) {
    if (or(a))
      return function(s) {
        return Me(s, a);
      };
    Me(a);
  }), xe = x(function(a) {
    B(a) ? _({
      type: "SET_FORMIK_STATE",
      payload: a
    }) : _({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return a;
      }
    });
  }, []), Ne = x(function(a) {
    _({
      type: "SET_STATUS",
      payload: a
    });
  }, []), De = x(function(a) {
    _({
      type: "SET_ISSUBMITTING",
      payload: a
    });
  }, []), be = U(function() {
    return _({
      type: "SUBMIT_ATTEMPT"
    }), L().then(function(a) {
      var s = a instanceof Error, l = !s && Object.keys(a).length === 0;
      if (l) {
        var y;
        try {
          if (y = fe(), y === void 0)
            return;
        } catch (b) {
          throw b;
        }
        return Promise.resolve(y).then(function(b) {
          return m.current && _({
            type: "SUBMIT_SUCCESS"
          }), b;
        }).catch(function(b) {
          if (m.current)
            throw _({
              type: "SUBMIT_FAILURE"
            }), b;
        });
      } else if (m.current && (_({
        type: "SUBMIT_FAILURE"
      }), s))
        throw a;
    });
  }), p = U(function(a) {
    if (a && a.preventDefault && B(a.preventDefault) && a.preventDefault(), a && a.stopPropagation && B(a.stopPropagation) && a.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
      var s = fu();
      s !== null && s instanceof HTMLButtonElement && (s.attributes && s.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? Z(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : Z()));
    }
    be().catch(function(l) {
      console.warn("Warning: An unhandled error was caught from submitForm()", l);
    });
  }), se = {
    resetForm: Q,
    validateForm: L,
    validateField: Re,
    setErrors: Pe,
    setFieldError: ce,
    setFieldTouched: q,
    setFieldValue: K,
    setStatus: Ne,
    setSubmitting: De,
    setTouched: ye,
    setValues: he,
    setFormikState: xe,
    submitForm: be
  }, fe = U(function() {
    return A(g.values, se);
  }), Le = U(function(a) {
    a && a.preventDefault && B(a.preventDefault) && a.preventDefault(), a && a.stopPropagation && B(a.stopPropagation) && a.stopPropagation(), Q();
  }), Dt = x(function(a) {
    return {
      value: V(g.values, a),
      error: V(g.errors, a),
      touched: !!V(g.touched, a),
      initialValue: V(T.current, a),
      initialTouched: !!V(F.current, a),
      initialError: V(S.current, a)
    };
  }, [g.errors, g.touched, g.values]), Lt = x(function(a) {
    return {
      setValue: function(l, y) {
        return K(a, l, y);
      },
      setTouched: function(l, y) {
        return q(a, l, y);
      },
      setError: function(l) {
        return ce(a, l);
      }
    };
  }, [K, q, ce]), Vt = x(function(a) {
    var s = qe(a), l = s ? a.name : a, y = V(g.values, l), b = {
      name: l,
      value: y,
      onChange: me,
      onBlur: ge
    };
    if (s) {
      var O = a.type, N = a.value, z = a.as, Qe = a.multiple;
      O === "checkbox" ? N === void 0 ? b.checked = !!y : (b.checked = !!(Array.isArray(y) && ~y.indexOf(N)), b.value = N) : O === "radio" ? (b.checked = y === N, b.value = N) : z === "select" && Qe && (b.value = b.value || [], b.multiple = !0);
    }
    return b;
  }, [ge, me, g.values]), Je = Or(function() {
    return !re(T.current, g.values);
  }, [T.current, g.values]), Ut = Or(function() {
    return typeof v < "u" ? Je ? g.errors && Object.keys(g.errors).length === 0 : v !== !1 && B(v) ? v(f) : v : g.errors && Object.keys(g.errors).length === 0;
  }, [v, Je, g.errors, f]), Bt = D({}, g, {
    initialValues: T.current,
    initialErrors: S.current,
    initialTouched: F.current,
    initialStatus: C.current,
    handleBlur: ge,
    handleChange: me,
    handleReset: Le,
    handleSubmit: p,
    resetForm: Q,
    setErrors: Pe,
    setFormikState: xe,
    setFieldTouched: q,
    setFieldValue: K,
    setFieldError: ce,
    setStatus: Ne,
    setSubmitting: De,
    setTouched: ye,
    setValues: he,
    submitForm: be,
    validateForm: L,
    validateField: Re,
    isValid: Ut,
    dirty: Je,
    unregisterField: ke,
    registerField: Ze,
    getFieldProps: Vt,
    getFieldMeta: Dt,
    getFieldHelpers: Lt,
    validateOnBlur: o,
    validateOnChange: t,
    validateOnMount: u
  });
  return Bt;
}
function pu(e) {
  var r = du(e), t = e.component, n = e.children, o = e.render, i = e.innerRef;
  return Ht(i, function() {
    return r;
  }), process.env.NODE_ENV !== "production" && G(function() {
    e.render && (process.env.NODE_ENV !== "production" ? Z(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : Z());
  }, []), cr(iu, {
    value: r
  }, t ? cr(t, r) : o ? o(r) : n ? B(n) ? n(r) : su(n) ? null : ot.only(n) : null);
}
function at(e) {
  var r = e.htmlContent, t = e.documentationAnchorLink, n = e.handlerName;
  console.warn("Warning: Formik called `" + n + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + r + `
    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#` + t + `
  `);
}
function vu(e) {
  var r = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return te(r, e.path, e.message);
    for (var o = e.inner, t = Array.isArray(o), n = 0, o = t ? o : o[Symbol.iterator](); ; ) {
      var i;
      if (t) {
        if (n >= o.length) break;
        i = o[n++];
      } else {
        if (n = o.next(), n.done) break;
        i = n.value;
      }
      var u = i;
      V(r, u.path) || (r = te(r, u.path, u.message));
    }
  }
  return r;
}
function yu(e, r, t, n) {
  t === void 0 && (t = !1);
  var o = vr(e);
  return r[t ? "validateSync" : "validate"](o, {
    abortEarly: !1,
    context: o
  });
}
function vr(e) {
  var r = Array.isArray(e) ? [] : {};
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      var n = String(t);
      Array.isArray(e[n]) === !0 ? r[n] = e[n].map(function(o) {
        return Array.isArray(o) === !0 || Cr(o) ? vr(o) : o !== "" ? o : void 0;
      }) : Cr(e[n]) ? r[n] = vr(e[n]) : r[n] = e[n] !== "" ? e[n] : void 0;
    }
  return r;
}
function hu(e, r, t) {
  var n = e.slice();
  return r.forEach(function(i, u) {
    if (typeof n[u] > "u") {
      var v = t.clone !== !1, h = v && t.isMergeableObject(i);
      n[u] = h ? sr(Array.isArray(i) ? [] : {}, i, t) : i;
    } else t.isMergeableObject(i) ? n[u] = sr(e[u], i, t) : e.indexOf(i) === -1 && n.push(i);
  }), n;
}
function mu(e) {
  return Array.from(e).filter(function(r) {
    return r.selected;
  }).map(function(r) {
    return r.value;
  });
}
function gu(e, r, t) {
  if (typeof e == "boolean")
    return !!r;
  var n = [], o = !1, i = -1;
  if (Array.isArray(e))
    n = e, i = e.indexOf(t), o = i >= 0;
  else if (!t || t == "true" || t == "false")
    return !!r;
  return r && t && !o ? n.concat(t) : o ? n.slice(0, i).concat(n.slice(i + 1)) : n;
}
var bu = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? qt : G;
function U(e) {
  var r = X(e);
  return bu(function() {
    r.current = e;
  }), x(function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    return r.current.apply(void 0, n);
  }, []);
}
var Tu = /* @__PURE__ */ it(function(e, r) {
  var t = e.action, n = xt(e, ["action"]), o = t ?? "#", i = uu(), u = i.handleReset, v = i.handleSubmit;
  return cr("form", D({
    onSubmit: v,
    ref: r,
    onReset: u,
    action: o
  }, n));
});
Tu.displayName = "Form";
function Eu(e, r) {
  const {
    initialValues: t,
    validationSchema: n,
    onSubmit: o,
    children: i,
    validateOn: u = "submit",
    className: v,
    ...h
  } = e, d = u === "change", A = u === "blur";
  return /* @__PURE__ */ ur.jsx(
    pu,
    {
      initialValues: t,
      validationSchema: n,
      onSubmit: o,
      validateOnChange: d,
      validateOnBlur: A,
      validateOnMount: !1,
      innerRef: r,
      children: (E) => /* @__PURE__ */ ur.jsx(
        ut,
        {
          onSubmit: E.handleSubmit,
          className: v,
          errors: E.errors,
          onClearErrors: E.setErrors,
          ...h,
          children: typeof i == "function" ? i(E) : i
        }
      )
    }
  );
}
const Cu = it(Eu);
export {
  Cu as default
};
